import { Send } from '@mui/icons-material'
import { Box, IconButton, Paper, TextField } from '@mui/material'
import type React from 'react'
import { type KeyboardEvent, useState } from 'react'

interface ChatInputProps {
  onSendMessage: (message: string) => void
  disabled?: boolean
}

export const ChatInput: React.FC<ChatInputProps> = ({ onSendMessage, disabled = false }) => {
  const [message, setMessage] = useState('')

  const handleSubmit = () => {
    if (message.trim() && !disabled) {
      onSendMessage(message.trim())
      setMessage('')
    }
  }

  const handleKeyPress = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      handleSubmit()
    }
  }

  return (
    <Paper
      elevation={2}
      sx={{
        p: { xs: 1, sm: 2 },
        mx: { xs: -1, sm: 0 },
        borderRadius: { xs: 0, sm: 2 },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: { xs: 0.5, sm: 1 } }}>
        <TextField
          fullWidth
          multiline
          maxRows={4}
          variant="outlined"
          placeholder="Type your message..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyPress={handleKeyPress}
          disabled={disabled}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
              fontSize: { xs: '0.9rem', sm: '1rem' },
            },
            '& .MuiOutlinedInput-input': {
              py: { xs: 1, sm: 1.5 },
            },
          }}
        />
        <IconButton
          color="primary"
          onClick={handleSubmit}
          disabled={disabled || !message.trim()}
          sx={{
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            width: { xs: 36, sm: 42 },
            height: { xs: 36, sm: 42 },
            '&:hover': {
              bgcolor: 'primary.dark',
            },
            '&:disabled': {
              bgcolor: 'grey.300',
            },
            '& .MuiSvgIcon-root': {
              fontSize: { xs: '1rem', sm: '1.25rem' },
            },
          }}
        >
          <Send />
        </IconButton>
      </Box>
    </Paper>
  )
}
